import { Session } from '@supabase/supabase-js';
import { createContext } from 'react';

interface AuthContextProps {
  session: Session | null;
  logout: () => void;
}
export const AuthContext = createContext<AuthContextProps>({ session: null, logout: () => {} });
